<template>
  <div>
    <Header />
     <component :is="currentView" />
    <Footer />
  </div>
</template>

<script>
  import Project from './views/Project.vue'
  import About from "./views/About"
  import Header from './components/Header'
  import Footer from "@/components/Footer";
  import CV from "@/views/CV";
  import Media from "@/views/Media";
  import Project1 from "@/views/Project1";
  import Project2 from "@/views/Project2";
  import Project3 from "@/views/Project3";
  import Project4 from "@/views/Project4";
  import Project5 from "@/views/Project5";
  import Project6 from "@/views/Project6";
  import Project7 from "@/views/Project7";
  import Project8 from "@/views/Project8";
  import Project9 from "@/views/Project9";
  import Project10 from "@/views/Project10";
  import Project11 from "@/views/Project11";
  import Project12 from "@/views/Project12";
  import Project13 from "@/views/Project13";
  import Project14 from "@/views/Project14";

  const routes = {
     '/': Project,
    '/about': About,
      '/cv' :CV,
      '/media':Media,
      '/project1':Project1,
      '/project2':Project2,
      '/project3':Project3,
      '/project4':Project4,
      '/project5':Project5,
      '/project6':Project6,
      '/project7':Project7,
      '/project8':Project8,
      '/project9':Project9,
      '/project10':Project10,
      '/project11':Project11,
      '/project12':Project12,
      '/project13':Project13,
      '/project14':Project14,
  }

  export default {
    components:{
      Header,
        Footer
    },
    data() {
      return {
        currentPath: window.location.hash
      }
    },
    computed: {
      currentView() {
        return routes[this.currentPath.slice(1) || '/']
      }
    },
    mounted() {
      window.addEventListener('hashchange', () => {
        this.currentPath = window.location.hash
      })
    }
  }


</script>

<style>

</style>
